import React, { useState } from "react";
import ShippingForm from "./ShippingForm";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { ChevronRight, Ruler } from "lucide-react";
import { TbTax } from "react-icons/tb";

const VATForm = () => (
  <div className="bg-white p-6 rounded-lg">
    <h2 className="text-xl font-semibold text-gray-800 mb-4">
      VAT Configuration
    </h2>
    <p className="text-gray-600"> VAT settings here...</p>
  </div>
);

const UnitForm = () => (
  <div className="bg-white p-6 rounded-lg">
    <h2 className="text-xl font-semibold text-gray-800 mb-4">
      Unit Management
    </h2>
    <p className="text-gray-600"> units of measurement here...</p>
  </div>
);

const MasterModal = ({
  activeSection,
  setActiveSection,
  masterModalData,
  SetMasterModalData,
  closeModal,
}) => {
  const renderRightContent = () => {
    switch (activeSection) {
      case "shipping":
        return (
          <ShippingForm
            masterModalData={masterModalData}
            SetMasterModalData={SetMasterModalData}
            closeModal={closeModal}
          />
        );
      case "vat":
        return <VATForm />;
      case "unit":
        return <UnitForm />;
      //   case "area":
      //     return <AreaForm />;
      default:
        return (
          <div className="bg-white p-6 rounded-lg text-center">
            <div className="text-gray-400 mb-4">
              <svg
                className="w-16 h-16 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-600 mb-2">
              Select a Section
            </h3>
            <p className="text-gray-500">
              Choose a master configuration section from the left menu to get
              started
            </p>
          </div>
        );
    }
  };

  const menuItems = [
    {
      id: "shipping",
      label: "Shipping",
      icon: <LocalShippingIcon />,
      disable: false,
    },
    { id: "vat", label: "VAT", icon: <TbTax />, disable: true },
    { id: "unit", label: "Unit", icon: <Ruler />, disable: true },
    // { id: "area", label: "Area", icon: "" },
  ];

  return (
    <div className="bg-gray-50  p-4">
      <div className="bg-white rounded-lg">
        <div className="flex flex-col lg:flex-row min-h-full">
          <div className="w-full lg:w-1/4 bg-gray-50 border-b lg:border-b-0 lg:border-r border-gray-200 p-2">
            <div className="mb-2 lg:mb-4">
              <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide lg:block hidden">
                Master Settings
              </h3>
            </div>

            <nav className="flex flex-row lg:flex-col gap-2 lg:gap-1 overflow-x-auto">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => setActiveSection(item.id)}
                  disabled={item.disable}
                  title={item.disable ? "Menu not Available" : `${item.label}`}
                  className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${
                    activeSection === item.id
                      ? "bg-blue-100 text-blue-700 border border-blue-200 shadow-sm"
                      : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                  }`}
                >
                  <span className="text-lg">{item.icon}</span>
                  <span className="hidden sm:inline">{item.label}</span>

                  {/* Chevron only on large screens */}
                  {activeSection === item.id && (
                    <span className="ml-auto hidden lg:flex">
                      <ChevronRight className="w-4 h-4" />
                    </span>
                  )}
                </button>
              ))}
            </nav>
          </div>

          {/* Right Content Area */}
          <div className="w-full lg:w-3/4 flex-1">{renderRightContent()}</div>
        </div>
      </div>
    </div>
  );
};
export default MasterModal;
